export const PRODUCT_DIMENSION_NAME = 'product id';
